export const AUDIT_VALUE_NULL = 'null'
export const AUDIT_VALUE_BOOLEAN = 'boolean'
export const AUDIT_VALUE_SCALAR = 'scalar'
export const AUDIT_VALUE_LIST = 'list'
export const AUDIT_VALUE_OBJECT = 'object'

